(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fta-collection-folding"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.getElementById('MainContent');
    if (!root || root.dataset.ftaCollectionCroReady === 'true') return;
    root.dataset.ftaCollectionCroReady = 'true';

    const makeFold = (container, selectors) => {
      if (!container) return null;

      const nodes = [];
      selectors.forEach((selector) => {
        container.querySelectorAll(selector).forEach((node) => {
          if (node.parentElement === container && !nodes.includes(node)) nodes.push(node);
        });
      });

      if (!nodes.length) return null;

      const details = document.createElement('details');
      details.className = 'fta-collection-fold';

      const summary = document.createElement('summary');
      summary.textContent = 'About this collection';

      const content = document.createElement('div');
      content.className = 'fta-collection-fold__content';

      nodes[0].before(details);
      details.append(summary, content);
      nodes.forEach((node) => content.append(node));
      return details;
    };

    makeFold(root.querySelector('.fta-women-v2__hero-copy'), [
      '.fta-women-v2__intro',
      '.fta-women-v2__note'
    ]);

    makeFold(root.querySelector('.fta-women__hero-copy'), [
      '.fta-women__intro',
      '.fta-women__hero-note'
    ]);

    makeFold(root.querySelector('.fta-men__hero-copy'), [
      '.fta-men__intro',
      '.fta-men__hero-note'
    ]);

    makeFold(root.querySelector('.fta-accessories__hero-copy'), [
      '.fta-accessories__intro'
    ]);

    makeFold(root.querySelector('.fta-alpaca-hero__copy'), [
      '.fta-alpaca-lede',
      '.fta-alpaca-hero__note'
    ]);

    makeFold(root.querySelector('.fall-hero__copy'), [
      '.fall-curator'
    ]);

    makeFold(root.querySelector('.fta-kids__hero-inner'), [
      '.fta-kids__intro'
    ]);

    makeFold(root.querySelector('.fta-ritual-copy'), [
      '.fta-ritual-intro'
    ]);

    makeFold(root.querySelector('.fta-mask-hero-copy'), [
      '.fta-mask-intro'
    ]);

    makeFold(root.querySelector('.fta-hero'), [
      '.fta-intro'
    ]);

    makeFold(root.querySelector('.fta-jewelry-hero__copy'), [
      ':scope > p:not(.fta-jewelry-eyebrow)'
    ]);

    makeFold(root.querySelector('.fta-home-decor-hero__copy'), [
      ':scope > p:not(.fta-home-decor-eyebrow)'
    ]);

    makeFold(root.querySelector('.fta-sculpture-hero__copy'), [
      ':scope > p:not(.fta-sculpture-eyebrow)'
    ]);

    const disclosures = Array.from(
      root.querySelectorAll('details.fta-collection-fold, details.fta-collection-description')
    );

    if (!disclosures.length) return;

    const primary = disclosures[0];
    primary.classList.add('fta-collection-fold');
    primary.classList.remove('fta-collection-description');

    let primarySummary = primary.querySelector(':scope > summary');
    if (!primarySummary) {
      primarySummary = document.createElement('summary');
      primary.prepend(primarySummary);
    }
    primarySummary.textContent = 'About this collection';

    let primaryContent =
      primary.querySelector(':scope > .fta-collection-fold__content') ||
      primary.querySelector(':scope > .fta-collection-description__content');

    if (!primaryContent) {
      primaryContent = document.createElement('div');
      primaryContent.className = 'fta-collection-fold__content';
      Array.from(primary.children).forEach((child) => {
        if (child !== primarySummary) primaryContent.append(child);
      });
      primary.append(primaryContent);
    } else {
      primaryContent.classList.add('fta-collection-fold__content');
      primaryContent.classList.remove('fta-collection-description__content');
    }

    disclosures.slice(1).forEach((details) => {
      const content =
        details.querySelector(':scope > .fta-collection-fold__content') ||
        details.querySelector(':scope > .fta-collection-description__content');

      if (content) {
        while (content.firstChild) primaryContent.append(content.firstChild);
      } else {
        Array.from(details.children).forEach((child) => {
          if (child.tagName !== 'SUMMARY') primaryContent.append(child);
        });
      }

      details.remove();
    });

    const merchandiseSelectors = [
      '#product-grid',
      '.fta-women-v2__grid',
      '.fta-women__grid',
      '.fta-men__grid',
      '.fta-accessories__grid',
      '.fta-kids__grid',
      '.fall-grid',
      '.fta-alpaca-product-grid',
      '.fta-mask-grid',
      '.fta-ritual-grid',
      '.fta-grid'
    ];

    const merchandise = Array.from(
      root.querySelectorAll(merchandiseSelectors.join(','))
    );

    const anchor = merchandise.length ? merchandise[merchandise.length - 1] : null;

    let placement = root.querySelector('.fta-collection-about-placement');
    if (!placement) {
      placement = document.createElement('section');
      placement.className = 'fta-collection-about-placement';
      placement.setAttribute('aria-label', 'Collection information');
    }

    placement.append(primary);

    if (anchor && anchor.parentElement) {
      anchor.after(placement);
    } else {
      root.append(placement);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fta-white-glove-service-base"] && !Shopify.designMode) return;
  try {
    (() => {
    let lastOpener = null;

    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      const opener = target.closest('[data-fta-white-glove-open]');
      if (opener) {
        const dialogId = opener.getAttribute('data-fta-white-glove-open');
        const dialog = dialogId ? document.getElementById(dialogId) : null;

        if (dialog && typeof dialog.showModal === 'function' && !dialog.open) {
          lastOpener = opener;
          dialog.showModal();
          document.documentElement.classList.add('fta-white-glove-dialog-open');
        }
        return;
      }

      const closer = target.closest('[data-fta-white-glove-close]');
      if (closer) {
        const dialog = closer.closest('dialog');
        if (dialog && dialog.open) dialog.close();
      }
    });

    document.addEventListener(
      'close',
      (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target || !target.matches('dialog.fta-white-glove-dialog')) return;

        if (!document.querySelector('dialog.fta-white-glove-dialog[open]')) {
          document.documentElement.classList.remove('fta-white-glove-dialog-open');
        }

        if (lastOpener && document.contains(lastOpener)) {
          lastOpener.focus();
          lastOpener = null;
        }
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
